import React, { useState } from 'react';
import {
  Box, Paper, Typography, TextField, Button, Tab, Tabs,
  Alert, Stack, Divider, InputAdornment, IconButton,
} from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { customLogin, customRegister } from '../services/auth';

export default function Login() {
  const [tab, setTab] = useState(0); // 0=login, 1=register
  const [form, setForm] = useState({ username: '', password: '' });
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const set = (field) => (e) => setForm((f) => ({ ...f, [field]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      if (tab === 0) {
        await customLogin(form.username, form.password);
      } else {
        if (form.password.length < 8) return setError('Password must be at least 8 characters.');
        await customRegister(form.username, form.password);
      }
      window.location.href = '/';
    } catch (err) {
      setError(err.message || 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" minHeight="100vh" sx={{ bgcolor: 'background.default', p: 2 }}>
      <Typography variant="h3" fontWeight="bold" color="primary" gutterBottom>TripVibe</Typography>
      <Typography color="text.secondary" mb={3}>Rate your family adventures</Typography>

      <Paper sx={{ width: '100%', maxWidth: 420, p: 4, borderRadius: 3 }}>
        <Tabs value={tab} onChange={(_, v) => { setTab(v); setError(''); }} variant="fullWidth" sx={{ mb: 3 }}>
          <Tab label="Sign In" />
          <Tab label="Create Account" />
        </Tabs>

        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

        <Box component="form" onSubmit={handleSubmit}>
          <Stack spacing={2}>
            <TextField label="Username" fullWidth required autoFocus value={form.username} onChange={set('username')} />
            <TextField
              label="Password" fullWidth required type={showPassword ? 'text' : 'password'}
              value={form.password} onChange={set('password')}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => setShowPassword((s) => !s)} edge="end">
                      {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <Button type="submit" variant="contained" size="large" disabled={loading} fullWidth>
              {loading ? (tab === 0 ? 'Signing in...' : 'Creating account...') : (tab === 0 ? 'Sign In' : 'Create Account')}
            </Button>
          </Stack>
        </Box>

        <Divider sx={{ my: 3 }}>or</Divider>

        <Button
          variant="outlined" fullWidth size="large"
          href="/.auth/login/aad"
          startIcon={<img src="https://www.microsoft.com/favicon.ico" width={16} alt="" />}
        >
          Sign in with Microsoft
        </Button>
      </Paper>
    </Box>
  );
}
